import { quizNavigationBlockerExcludePaths } from '@repo/lib/quiz/quizNavigationBlockerExcludePaths';

import { NavigationBlockerDialog } from '@/components/features/navigation/NavigationBlockerDialog';
import { useQuizResolverStore } from '@/store/quiz-store';

export interface QuizNavigationBlockerDialogProps {
  enabled?: boolean;
}

export default function QuizNavigationBlockerDialog(quizNavigationBlockerDialogProps: QuizNavigationBlockerDialogProps) {
  const { enabled = true } = quizNavigationBlockerDialogProps;
  const clear = useQuizResolverStore((state) => state.clear);

  return (
    <NavigationBlockerDialog
      enabled={enabled}
      excludePaths={quizNavigationBlockerExcludePaths}
      onProceed={clear}
      title="Czy na pewno chcesz opuścić quiz?"
      description="Możesz wrócić później, ale czas będzie nadal odliczany."
      confirmLabel="Opuść quiz"
    />
  );
}
